// extracted by mini-css-extract-plugin
export default {"newTab":"newtab_newTab__9E04L"};